export enum AcceptFormat {
  png = 'image/png',
  jpeg = 'image/jpeg',
  jpg = 'image/jpg',
  svg = 'image/svg+xml',
  pdf = 'application/pdf',
  msword = 'application/msword',
  document = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
}
